import React from 'react'
import { useInventoryBySerialNumberListContext } from './Context'
import { DataTool } from '@ztechapps/webui.data-tools'
import { listFieldConfig } from './constants'
import { AddInventoryBySerialNumber } from './AddInventoryBySerialNumber'

export const InventoryBySerialNumberListToolbox = () => {
  const { inventorybyserialnumberList, filterCategory } = useInventoryBySerialNumberListContext()
  return (
    <DataTool
      fieldsConfig={listFieldConfig}
      {...inventorybyserialnumberList}
      searchPlaceHolder="Search"
      filterCategory={filterCategory}
      onSort={null}
      components={{
        other: AddInventoryBySerialNumber,
      }}
    />
  )
}
